import { render, staticRenderFns } from "./Age_Community.vue?vue&type=template&id=33dd35b3"
import script from "./Age_Community.vue?vue&type=script&lang=js"
export * from "./Age_Community.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports